<section id="iq-service" class="services-container">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <app-v-two-section-title [titleSectionProp]="titleSectionProp"></app-v-two-section-title>
            </div>
            <div *ngFor="let list of List" [class]="list.type== serviceType.space?'col-lg-2':'col-lg-4'" (click)="serviceClick(list.title)" [routerLink]="list.url ? [list.url] : []" [class.url-indicator]="list.url">
                <div *ngIf="list.type!=1 " class="box-effect-two  wow fadeInUp text-center feature-box-effect {{ list.active !== undefined && list.active ? 'selected' : '' }} ">
                    <div class="icon-box">
                        <div class="img-effect mb-4"><img src="{{ list.image }}" alt="fancybox"></div>
                        <h5 class="mb-2">{{ list.title }}</h5>
                        <p class="mb-0">{{ list.desc }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>